import {useEffect} from "react";
import AuthContext from "../context/AuthContext";
import { useContextSelector } from "use-context-selector";
const Logout = () => {
  const logoutUser = useContextSelector(AuthContext, (ctx) => ctx.logoutUser);
  useEffect(() => {
    logoutUser();
  }, []);

  return <div></div>;
};

export default Logout;
